import { useQuery } from '@tanstack/react-query'
import { getFromRepo } from '@core/Utils/repository'
import { AccountHolders, AccountHoldersKey } from '@core/Data/Account/accountHolder'
import { queryKeys } from '@core/Data/ReactQuery/constants'

export const useActivityStatementQuery = (accountNumber: number | undefined | null) =>
  useQuery({
    queryKey: [queryKeys.activityStatementsAccountHolders, accountNumber],
    queryFn: () => getFromRepo(AccountHolders, AccountHoldersKey),
    enabled: !!accountNumber,
    gcTime: 0, // fallback on rwwa-data-access cache
  })
